import React from 'react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  return (
    <footer className="bg-willard-black text-white border-t border-willard-grey-800 mt-auto">
      <div className="max-w-6xl mx-auto px-5 py-12">
        <div className="flex flex-col sm:flex-row items-center sm:items-start justify-between gap-8">
          <div className="text-center sm:text-left">
            <div className="flex items-center gap-3 justify-center sm:justify-start">
              <img src="/assets/logos/W-logo.png" alt="Willard W" className="h-8 invert" />
              <p className="font-display text-lg">WILLARD TIGERS BOWLING</p>
            </div>
            <p className="text-sm text-willard-taupe font-bold uppercase tracking-[0.2em] mt-2">
              Focused · Connected · Driven
            </p>
          </div>
          <nav className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm font-bold text-willard-grey-400">
            <Link to="/roster" className="hover:text-willard-taupe transition-colors">Team</Link>
            <Link to="/stats" className="hover:text-willard-taupe transition-colors">Stats</Link>
            <Link to="/schedule" className="hover:text-willard-taupe transition-colors">Schedule</Link>
            <Link to="/about" className="hover:text-willard-taupe transition-colors">About</Link>
            <Link to="/contact" className="hover:text-willard-taupe transition-colors">Join the Tigers</Link>
          </nav>
        </div>
        <p className="text-xs text-willard-grey-600 mt-10 text-center sm:text-left">
          © {new Date().getFullYear()} Willard Tigers Bowling · Willard High School, Willard, MO
        </p>
      </div>
    </footer>
  );
};
